import React from 'react'
import { Container, Icon } from 'gu-ui-kit'
import styles from 'modules/Referral/PayoutProfiles/List/subcomponents/StatusIcon/status-icon.module.scss'

const StatusIcon = () => (
  <Container display={'flex'} className={styles['container']}>
    <Icon name={'user'} size={'m'} className={styles['icon']} />
  </Container>
)

StatusIcon.propTypes = {}

export default StatusIcon
